import React, { useState } from 'react';

interface BookCollaborationIntroProps {
  onDontShowAgainChange?: (dontShowAgain: boolean) => void;
}

export const BookCollaborationIntro: React.FC<BookCollaborationIntroProps> = ({
  onDontShowAgainChange,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleCheckboxChange = (checked: boolean) => {
    setDontShowAgain(checked);
    onDontShowAgainChange?.(checked);
  };

  return (
    <div className="text-center px-4" data-testid="book-collaboration-step">
      <h2 className="text-2xl font-bold text-center mb-4">Book Team-Up!</h2>
      <p className="text-center text-neutral-800 text-opacity-80 text-base font-normal mb-6">
        Take turns with your friend to write a book together!
      </p>

      <div className="bg-gray-100 rounded-xl p-6 mb-6">
        <div className="flex justify-center items-center space-x-4">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden">
              <img
                src={require('../../../assets/placeholder-avatar-1.png')}
                alt="You"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="mt-2 text-sm">You</span>
          </div>

          <div className="text-gray-400">→</div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden">
              <img
                src={require('../../../assets/placeholder-avatar-2.png')}
                alt="Anna"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="mt-2 text-sm">Anna</span>
          </div>

          <div className="text-gray-400">→</div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden">
              <img
                src={require('../../../assets/placeholder-avatar-1.png')}
                alt="You"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="mt-2 text-sm">You</span>
          </div>

          <div className="text-gray-400">→</div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden">
              <img
                src={require('../../../assets/placeholder-avatar-2.png')}
                alt="Anna"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="mt-2 text-sm">Anna</span>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          <div className="flex items-center">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-200 flex items-center justify-center mr-3">
              <span className="text-purple-700 font-bold">1</span>
            </div>
            <p className="text-left text-gray-600">You create Chapter 1</p>
          </div>

          <div className="flex items-center">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-200 flex items-center justify-center mr-3">
              <span className="text-purple-700 font-bold">2</span>
            </div>
            <p className="text-left text-gray-600">
              Your friend creates Chapter 2
            </p>
          </div>

          <div className="flex items-center">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-200 flex items-center justify-center mr-3">
              <span className="text-purple-700 font-bold">3</span>
            </div>
            <p className="text-left text-gray-600">
              Keep taking turns until your book is complete!
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-start">
        <input
          type="checkbox"
          id="dont-show-again"
          className="mr-2"
          checked={dontShowAgain}
          onChange={(e) => handleCheckboxChange(e.target.checked)}
        />
        <label htmlFor="dont-show-again" className="text-sm text-gray-600">
          Don't show this again
        </label>
      </div>
    </div>
  );
};

export default BookCollaborationIntro;
